import { render, staticRenderFns } from "./CustomerWarrantyHistoryTab.vue?vue&type=template&id=2810bcee&scoped=true"
import script from "./CustomerWarrantyHistoryTab.vue?vue&type=script&lang=js"
export * from "./CustomerWarrantyHistoryTab.vue?vue&type=script&lang=js"
import style0 from "./CustomerWarrantyHistoryTab.vue?vue&type=style&index=0&id=2810bcee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2810bcee",
  null
  
)

export default component.exports